module.exports = __webpack_public_path__ + "assets/ticket.91d7ed333e03c94ca2b308b974d95d05.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/ticket.png
 ** module id = 211
 ** module chunks = 0
 **/